import { render, staticRenderFns } from "./class-home.vue?vue&type=template&id=8ae9a59a&scoped=true"
import script from "./class-home.vue?vue&type=script&lang=js"
export * from "./class-home.vue?vue&type=script&lang=js"
import style0 from "./class-home.vue?vue&type=style&index=0&id=8ae9a59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae9a59a",
  null
  
)

export default component.exports